import {NavLink} from "react-router-dom";
import {Icon} from "../components";
import React from "react";

export default function Navitem({path, icon, text, component, ...props}) {
  return (
    <li className="panel ">
      <NavLink
        className="side-menu-dropdown"
        to={path}
        {...props}
      >
        {icon ? <Icon icon={icon} text={text}/> : <span>{text}</span>}
      </NavLink>
      {props.children}
    </li>
  )
}
